import _ from 'lodash'

import { filtersRequiringDestinations } from '../../configuration/filtering'

export function getFilterSetFromTourResults(destinations, filterKey, searchResults) {
  let availableFilters = _.flatMap(searchResults, result => _.get(result, `[${filterKey}]`, []))
  availableFilters = _.uniq(availableFilters)
  availableFilters = _.sortBy(availableFilters)

  if (_.includes(filtersRequiringDestinations, filterKey)) {
    availableFilters = _.reduce(availableFilters, (filterMap, filter) => {
      return _.get(destinations, `[${filter}]`)
        ? { ...filterMap, [`${filter}`]: _.get(destinations, `[${filter}]`) }
        : filterMap
    }, {})
  }

  return availableFilters
}

export function formatDestinations(destinations) {
  const filteredDestinations = _.filter(destinations, destination => _.get(destination, 'published'))
  return _.reduce(filteredDestinations, (destinationsMap, destination) => {
    return {
      ...destinationsMap,
      [`${destination.id}`]: _.get(destination, 'name')
    }
  }, {})
}
